import React, { useState } from "react";
import { Alert, Image, StyleSheet, View } from "react-native";
import * as Yup from "yup";
import Screen from "../components/Screen";
import colors from "../config/colors";
import AppButton from "../components/AppButton";
import ActivityIndicator from "../components/ActivityIndicator";
import useApi from "../hooks/useApi";
import auth from "../api/auth";
import AppText from "../components/AppText";
import { AppForm, AppFormField, SubmitButton } from "../components/forms";
import { StdAlert } from "../components/CustomAlert";

const validationSchema = Yup.object().shape({
  password: Yup.string().required().min(4).label("Password"),
  otp: Yup.string().required().min(6).label("OTP"),
});

function OTPScreen({ navigation, route }) {
  const [password, setPassword] = useState("");
  const otpApi = useApi(auth.otp);
  const [code, setCode] = useState("");

  const handleSubmit = async ({ password, otp }) => {
    console.log(password, otp, "ls");
    if (password.length >= 4) {
      const result = await otpApi.request(password, otp);
      console.log(result.data);

      if (result.data.response.code === "200") {
        StdAlert(
          "Success",
          "You have successfully changed your password.",
          () => navigation.navigate("Login")
        );
        // Alert.alert(
        //   "Success",
        //   "You have successfully changed your password..",
        //   [
        //     // {
        //     //   text: 'Cancel',
        //     //   onPress: () => console.log('Cancel Pressed'),
        //     //   style: 'cancel',
        //     // },
        //     {
        //       text: "Back to Login",
        //       onPress: () => navigation.navigate("Login"),
        //     },
        //   ],
        //   { cancelable: false }
        // );
      } else {
        StdAlert(
          "",
          result.data.response.custom_message ||
            "Some error occured. Please, try again."
        );
        // Alert.alert(
        //   "",
        //   result.data.response.custom_message ||
        //     "Some error occured. Please, try again."
        // );
      }
    }
  };

  return (
    <Screen>
      <Image
        source={require("../assets/paris_portrait.jpg")}
        style={{
          height: "100%",
          width: "100%",
          position: "absolute",
          // resizeMode: "contain",
        }}
      />
      <ActivityIndicator visible={otpApi.loading} />
      <AppForm
        initialValues={{ password: "", otp: "" }}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        <View style={styles.logo}>
          <AppText
            color="transparent"
            textColor="white"
            style={{
              fontSize: 20,
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: 15,
            }}
          >
            Please, check your email and{"\n"} Enter the Reset Code below, along
            with your new password.
          </AppText>
          <AppFormField
            style={{ marginLeft: 5, marginVertical: 10 }}
            autoCapitalize="none"
            autoCorrect={false}
            icon="contact-phone"
            name="otp"
            placeholder="Reset Code"
            login
            // textContentType="telephoneNumber"
            // keyboardType={Platform.OS === "ios" ? "number-pad" : "phone-pad"}
          />
          <AppFormField
            style={{ width: "100%", alignSelf: "center" }}
            autoCapitalize="none"
            autoCorrect={false}
            icon="lock"
            name="password"
            placeholder="New Password"
            secureTextEntry
            textContentType="password"
            login
          />
          {/* <OTPInputView
            style={{width: '80%', height: 150}}
            pinCount={6}
            // code={this.state.code} //You can supply this prop or not. The component will be used as a controlled / uncontrolled component respectively.
            onCodeChanged={(code) => setCode(code)}
            autoFocusOnLoad
            codeInputFieldStyle={styles.underlineStyleBase}
            codeInputHighlightStyle={styles.underlineStyleHighLighted}
            onCodeFilled={(codes) => {
              setCode(codes);
              handleSubmit(codes);
              console.log(`Code is ${codes}, you are good to go!`);
            }}
          /> */}
          <SubmitButton style={styles.submitButton} title="Submit" />
        </View>
      </AppForm>
    </Screen>
  );
}

const styles = StyleSheet.create({
  logo: {
    backgroundColor: colors.skyBlueTrans,
    flex: 1,
    paddingHorizontal: 20,
    alignItems: "center",
    justifyContent: "center",
  },

  submitButton: {
    marginTop: 20,
  },

  borderStyleBase: {
    width: 30,
    height: 45,
  },

  borderStyleHighLighted: {
    borderColor: colors.yellow,
  },

  underlineStyleBase: {
    width: 40,
    height: 45,
    borderWidth: 0,
    borderBottomWidth: 3,
    fontSize: 24,
  },

  underlineStyleHighLighted: {
    borderColor: colors.yellow,
  },
});

export default OTPScreen;
